import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Page } from '../../../components';
import { useStore } from '../../../store';
import ProductForm from './components/ProductForm';

export default observer(function CreateProductPage() {
  const { productStore } = useStore();
  const [newProduct] = useState(() => productStore.createProduct());

  return (
    <Page navigation={newProduct.displayName || 'New product'}>
      <ProductForm product={newProduct} />
    </Page>
  );
});
